// extracted by mini-css-extract-plugin
export default {"cell-empty":"styles_cell-empty__C5bWB"};